import { AIMS, SIM_SEARCH } from '@disco/constants/FeatureTypes'
import { isFeatureEnabled } from '@disco/state-management/selectors/business'

import { useSelector } from 'hooks/use-redux'

// Checks if similarity search is available via DISCO SIMSEARCH or AIMS.
export const useSimSearchEnabled = (): boolean => {
  const simSearchEnabled = useSelector(state =>
    isFeatureEnabled(state, { featureName: SIM_SEARCH }),
  )
  const aimsEnabled = useSelector(state =>
    isFeatureEnabled(state, { featureName: AIMS }),
  )
  return simSearchEnabled || aimsEnabled
}
